module.exports = __webpack_public_path__ + "media/truth_initiative/truth-logo-white_316x86-e12d86f2.svg";